import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  FloatInput,
} from "components/Input/Index.js";
import styled from "styled-components";
import TextInput from "components/Input/TextInput.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import { site } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageList from "@mui/material/ImageList";
import UserService from "services/UserService";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { definitionData, stateData } from "variables/MBM/lists/equipments";
import { equipmentinstalledData } from "variables/MBM/lists/campaign"
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import Button from "@mui/material/Button";
import { postMBMCampaignEquipment, putMBMCampaignEquipment } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function EquipmentDialog(props) {
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const { closeModal, refetch, mbmequipments, equipments, setEquipments, campaigngroup, campaignid } = props;
  const [selectedmbmequipment, setSelectedmbmequipment] = useState("");
  const [equipment, setEquipment] = useState(props.equipment || "");
  const [groups, setGroups] = useState(props.equipment?.parameters?.campaigngroup ? "" + props.equipment.parameters.campaigngroup : "");
  const [campaignname, setCampaignname] = useState(props.equipment?.parameters?.campaignname ? props.equipment.parameters.campaignname : "");
  const [localization, setLocalization] = useState(props.equipment?.parameters?.localization ? props.equipment.parameters.localization : "");
  const [installed, setInstalled] = useState(props.equipment?.parameters?.installed ? props.equipment.parameters.installed : "");

  const [equipmentsData, setEquipmentsData] = useState([]);

  console.log(props.equipment);
  console.log(groups);

  useEffect(() => {
    let tmpequipmentdata = mbmequipments.filter((item) =>
      !equipments || !equipments.find((x) => x.equipmentid == item.id) //que les équipements qui ne sont pas déjà dans la liste des équipement de la campagne
    );
    console.log(tmpequipmentdata);
    setEquipmentsData(tmpequipmentdata);
  }, []);

  useEffect(() => {
    if (
      equipment.equipmentid && groups.length > 0 && groups !== '0'
    ) {
      console.log(groups);
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [equipment.id, groups]);

  const handleEquipmentChange = (newValue) => {
    let newequipment = {};
    newequipment.equipmentid = newValue.id;
    newequipment.campaignid = campaignid;
    newequipment.parameters = {};
    newequipment.parameters.name = newValue.name;
    newequipment.parameters.definition = newValue.definition;
    setEquipment(newequipment);
    setSelectedmbmequipment(newValue);
  };

  const handleNameChange = (event) => {
    setCampaignname(event.target.value);
  };
  const handleLocalizationChange = (event) => {
    setLocalization(event.target.value);
  };
  const handleInstalledChange = (event) => {
    setInstalled(event.target.value);
  };

  const selectedEquipment = () => {
    let selected = {};
    if (selectedmbmequipment !== undefined) {
      selected = selectedmbmequipment;
    }
    return selected;
  };

  const handleSubmit = async (event) => {
    if (equipment.id)
      updateEquipment();
    else
      addEquipment();
  };

  const addEquipment = async () => {
    let equipmenttmp = { ...equipment };
    equipmenttmp.parameters.campaigngroup = groups;
    equipmenttmp.parameters.campaignname = campaignname;
    equipmenttmp.parameters.localization = localization;
    equipmenttmp.parameters.installed = installed;
    axios
      .post(
        postMBMCampaignEquipment(),
        {
          ...equipmenttmp
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Equipement ajouté");
          refetch();
          closeModal();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateEquipment = async () => {
    let equipmenttmp = { ...equipment };
    equipmenttmp.parameters.campaigngroup = groups;
    equipmenttmp.parameters.campaignname = campaignname;
    equipmenttmp.parameters.localization = localization;
    equipmenttmp.parameters.installed = installed;
    axios
      .put(
        putMBMCampaignEquipment(equipment.id),
        {
          ...equipmenttmp
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Equipement modifié");
          refetch();
          closeModal();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <AutocompleteInputMeters
                inputMargin={"1rem 0rem 0rem"}
                specialWidth={"97%"}
                inputTitle={"Equipement"}
                selected={selectedEquipment()}
                list={equipmentsData}
                handleChange={(_, newValue) =>
                  handleEquipmentChange(newValue)
                }
              />
            </div>

            <div>
              <TextInput
                inputTitle={"Type"}
                textInput={(equipment.parameters && definitionData.find((x) => x.id == equipment.parameters.definition)?.name) || ""}
                disabled
              />
            </div>
            <div>
              <TextInput
                inputTitle={"Nom dans la campagne"}
                textInput={campaignname}
                handleTextInputChange={handleNameChange}
                disabled={!equipment}
              />
            </div>
            <div>
              <TextInput
                inputTitle={"Détail de la localisation"}
                textInput={localization}
                handleTextInputChange={handleLocalizationChange}
                disabled={!equipment}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={"Etat de pose"}
                selectValue={installed}
                handleSelectValueChange={handleInstalledChange}
                data={equipmentinstalledData}
                disabled={!equipment}
              />
            </div>

          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            {
              equipment &&
              <div
                className={classes.treeVisible}
              >
                <TreeLabel>Choix du périmètre</TreeLabel>
                <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                  <EmbeddedEntitesTree
                    selectedIds={setGroups}
                    userSelectedIds={groups}
                    filterfromnode={campaigngroup}
                  />
                </ImageList>
              </div>
            }
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </div>
  );
}

export default EquipmentDialog;
